import * as stylex from "@stylexjs/stylex";
import { copy } from "@/copy";
import type { Breakpoint } from "@/domain/breakpoint";
import { savedTimeShown } from "@/domain/offline";
import { type Clock, clockAt } from "@/domain/time";
import "@/theme/tokens.stylex";
import { motion, sizes } from "@/theme/tokens.stylex";
import { OfflinePill } from "@/ui/OfflinePill";
import { useNetwork } from "./providers/network";
import { useAccountSettings } from "./providers/settings";
import { useTimeZone } from "./providers/timeZone";
type OfflineNoticeProps = {
  breakpoint: Breakpoint;
  inset: number;
  onWeather: boolean;
};
const styles = {
  pill: {
    kVAEAm: "xixxii4",
    kbCHJM: "x1lv9o36",
    krVfgx: "xy58vm5",
    kY2c9j: "x1w0boku",
    k1ekBW: "xx43nhv",
    kIyJzY: "x1fmhw06",
    kAMwcw: "x18l85",
    $$css: true
  },
  besideSidebar: (inset: number) => [{
    koQZXg: inset != null ? "x1ntlw0l" : inset,
    $$css: true
  }, {
    "--x-marginLeft": (val => typeof val === "number" ? val + "px" : val != null ? val : undefined)(inset)
  }]
};
export function OfflineNotice({
  breakpoint,
  inset,
  onWeather
}: OfflineNoticeProps) {
  const {
    showOfflinePill,
    savedAt
  } = useNetwork();
  const {
    clock
  } = useAccountSettings();
  const tz = useTimeZone();
  if (!showOfflinePill) return null;
  const showSaved = savedAt !== undefined && savedTimeShown(breakpoint, onWeather);
  return <OfflinePill label={copy.offline.label} {...showSaved && {
    meta: savedLabel(savedAt, clock, tz)
  }} xstyle={[styles.pill, styles.besideSidebar(inset)]} />;
}
function savedLabel(savedAt: string, clock: Clock, tz: string): string {
  return copy.offline.saved(clockAt(savedAt, clock, tz));
}